import { Phone, MessageCircle, Lock } from "lucide-react";
import { T, COORDINATORS } from "@/i18n";

export const Contact = ({ lang }) => {
  return (
    <>
      <section id="contact" data-testid="contact-section" className="relative py-20 sm:py-28">
        <div className="gc-waves" />
        <div className="relative z-10 mx-auto max-w-4xl px-4 sm:px-6">
          <p data-testid="contact-sub" className={`text-center text-sm uppercase tracking-[0.3em] text-[#FFE500] ${lang === "kn" ? "font-kn normal-case tracking-normal" : ""}`}>
            {T.contact.sub[lang]}
          </p>
          <h2 data-testid="contact-heading" className={`mt-3 text-center font-display text-4xl font-bold uppercase text-white sm:text-5xl ${lang === "kn" ? "font-kn normal-case" : ""}`}>
            {T.contact.heading[lang]}
          </h2>
          <div className="mt-12 grid gap-6 sm:grid-cols-2">
            {COORDINATORS.map((c, i) => (
              <div key={c.tel} data-testid={`coordinator-card-${i}`} className="gc-card-sheen rounded-2xl p-7 text-center">
                <h3 data-testid={`coordinator-name-${i}`} className="font-display text-xl font-bold uppercase tracking-wide text-white">
                  {c.name}
                </h3>
                <p data-testid={`coordinator-phone-${i}`} className="mt-2 text-lg font-semibold text-[#FFE500]">{c.phone}</p>
                <div className="mt-5 flex justify-center gap-3">
                  <a
                    data-testid={`coordinator-call-${i}`}
                    href={`tel:${c.tel}`}
                    className="flex items-center gap-2 rounded-full bg-[#FFE500] px-5 py-2.5 text-sm font-bold text-[#0B1233] transition-transform hover:scale-105"
                  >
                    <Phone className="h-4 w-4" /> {T.contact.call[lang]}
                  </a>
                  <a
                    data-testid={`coordinator-whatsapp-${i}`}
                    href={`https://wa.me/${c.tel.replace("+", "")}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-2 rounded-full border border-[#FFE500]/40 px-5 py-2.5 text-sm font-bold text-[#FFE500] transition-colors hover:bg-[#FFE500] hover:text-[#0B1233]"
                  >
                    <MessageCircle className="h-4 w-4" /> {T.contact.whatsapp[lang]}
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Privacy notice */}
      <section data-testid="privacy-section" className="border-t border-white/10 py-14">
        <div className="mx-auto max-w-3xl px-4 text-center sm:px-6">
          <Lock className="mx-auto h-6 w-6 text-[#FFE500]/70" />
          <h3 data-testid="privacy-heading" className={`mt-3 font-display text-lg font-bold uppercase tracking-wider text-white ${lang === "kn" ? "font-kn normal-case" : ""}`}>
            {T.privacy.heading[lang]}
          </h3>
          <p data-testid="privacy-body" className={`mt-4 text-sm leading-relaxed text-white/60 ${lang === "kn" ? "font-kn" : ""}`}>
            {T.privacy.body[lang]}
          </p>
        </div>
      </section>
    </>
  );
};
